// 'ja'と'ja-JP'を返す場合があるので最初二文字で判定
export const LOCALE = navigator.language.substr(0, 2);

// 対応ロケール
export const SUPPORT_LOCALE = ['en', 'ja'];
// ユーザのロケールが対象外の場合選択されるロケール
export const DEFAULT_LOCALE = 'en';
